import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NotificationService } from '../../notification/notification.service';
import { RewardsService } from '@features/rewards/rewards.service';
import { CurrencyComponent } from '@shared/currency/currency.component';
import { IconComponent } from '@shared/icon/icon.component';
import { LevelNewComponent as LevelNewComponent_1, LevelNewComponent } from '@shared/level-new/level-new.component';
import { NamePipe } from '@shared/pipes/name.pipe';
import { SessionService } from '@shared/session.service';
import { SocketService } from '@shared/socket.service';
import { transformName } from '@utils';

@Component({
  selector: 'app-profile-main',
  templateUrl: './profile-main.component.html',
  styleUrls: ['./profile-main.component.scss'],
  imports: [LevelNewComponent_1, IconComponent, FormsModule, CurrencyComponent, NamePipe],
})
export class ProfileMainComponent implements OnInit, AfterViewInit {
  @ViewChild(LevelNewComponent) levelNewComponent: LevelNewComponent;

  levelColor: string;

  ngAfterViewInit() {
    this.levelColor = this.levelNewComponent.levelColor;
  }

  steamTradeUrl = '';
  email = '';
  stats: {
    jackpot: {
      total: number;
      profit: number;
    };
    plinko: {
      total: number;
      profit: number;
    };
    coinflip: {
      total: number;
      profit: number;
    };
    cases: {
      total: number;
      profit: number;
    };
    casebattles: {
      total: number;
      profit: number;
    };
    mines: {
      total: number;
      profit: number;
    };
    towers: {
      total: number;
      profit: number;
    };
    overall: {
      total: number;
      profit: number;
    };
    wallet: {
      deposits: number;
      withdraws: number;
      profit: number;
    };
  } = {
    jackpot: {
      total: 0,
      profit: 0,
    },
    plinko: {
      total: 0,
      profit: 0,
    },
    coinflip: {
      total: 0,
      profit: 0,
    },
    cases: {
      total: 0,
      profit: 0,
    },
    casebattles: {
      total: 0,
      profit: 0,
    },
    mines: {
      total: 0,
      profit: 0,
    },
    towers: {
      total: 0,
      profit: 0,
    },
    overall: {
      total: 0,
      profit: 0,
    },
    wallet: {
      deposits: 0,
      withdraws: 0,
      profit: 0,
    },
  };

  statsArray = Object.keys(this.stats)
    .filter((key): key is keyof Omit<typeof this.stats, 'wallet'> => key !== 'wallet')
    .map((key) => ({
      name: transformName(key),
      total: this.stats[key].total,
      profit: this.stats[key].profit,
    }));

  constructor(public session: SessionService, private socketService: SocketService, private notificationsService: NotificationService, public rewardsService: RewardsService) {}

  async ngOnInit(): Promise<void> {
    this.steamTradeUrl = '';
    this.stats = await this.socketService.emit('player_stats');
  }

  async onSetTradeUrl() {
    const tradeUrl = await this.socketService.emit('trade_save', { trade: this.steamTradeUrl.trim() });
    if (tradeUrl) {
      this.steamTradeUrl = '';
      this.session.stats.trade_url = tradeUrl;
      this.notificationsService.success('Trade URL updated.');
    }
  }
}
